import { Injectable } from '@angular/core';
import { GridTableBody, TableCellAttribute, UserTableConstructorInfo } from 'src/app/interfaces/tables.interfaces';
import { ColumnTypes } from 'src/app/views/grid-user-list/grid-table.enum';
import { CellActionTypes } from '../../../tables/components/cell-actions.type';
import { SuggestedUser } from '../../relation-request.interface';
import { UserSearchTableConstructor } from '../search-table';

export const suggestedDoctorRowData: (user: SuggestedUser) => GridTableBody = ({
  user,
  doctorLinkStatus,
  doctor,
}: SuggestedUser) => {
  return {
    user,
    entityId: user.user_id,
    actorId: user.user_id,
    created: null,
    list: doctor && doctor.specialty.map((specialty) => specialty.title),
    manage: { status: Boolean(doctorLinkStatus), reason: doctorLinkStatus && doctorLinkStatus.status },
    tooltipValues: { [CellActionTypes.ADD]: 'TOOLTIP_SEND_REQUEST' },
  };
};

@Injectable()
export class SuggestedDoctorTable implements UserSearchTableConstructor {
  public buildTableData(items: SuggestedUser[]): UserTableConstructorInfo {
    return {
      header: this.getTableHeader(),
      body: this.getTableBody(items),
      attribute: this.getManageCellAttribute(),
    };
  }

  private getTableHeader(): ColumnTypes[] {
    return [ColumnTypes.USER, ColumnTypes.SPECIALTIES, ColumnTypes.DATE, ColumnTypes.MANAGE];
  }

  private getManageCellAttribute(): TableCellAttribute {
    return { value_class_front: 'manageRelation', key: 'manage' };
  }

  private getTableBody(items: SuggestedUser[]): GridTableBody[] {
    return items.map(suggestedDoctorRowData);
  }
}
